module.exports = __webpack_public_path__ + "img/mutai_banner.704a78f4.png";